import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import {
  InstitucionLieSnp,
  InstitucionDependenciaLieSnp,
  LieFormSnp,
  LieSnp,
  MenuClasificacionLieSnp,
  MenuInstitucionSedeLieSnp,
} from '@/shared/model/snp/lie.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';

@Component({})
export default class LieListadoComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return new LieFormSnp();
    },
  })
  public lieAgregar: LieFormSnp;

  public filtroLies = '';
  public liesFiltradas: Array<LieFormSnp> = [];
  public lies: Array<LieFormSnp> = [];

  public mostrarModalActivar = false;
  public mostrarModalDesactivar = false;
  public mostrarModalEliminar = false;
  public mostrarModalDetalle = false;

  public lieSeleccionada: LieFormSnp = new LieFormSnp();

  public instituciones: Array<MenuInstitucionSedeLieSnp> = [];
  public clasificaciones: Array<MenuClasificacionLieSnp> = [];

  public perPage = 15;
  public currentPage = 1;

  public readonly fieldsLies = [
    { key: 'nombreDeLinea', label: this.$t('apeironGwApp.lieSnp.form.nombreDeLaLie'), class: 'text-left', thStyle: { width: '6rem' } },
    {
      key: 'clasificacion.nombre',
      label: this.$t('apeironGwApp.lieSnp.form.clasificacion'),
      class: 'text-left',
      thStyle: { width: '5rem' },
    },
    { key: 'activo', label: this.$t('apeironGwApp.lieSnp.form.activo'), class: 'text-left', thStyle: { width: '2rem' } },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.lieSnp.acciones.acciones'),
      class: 'text-center btn-acciones',
      thStyle: { width: '8rem' },
    },
  ];

  public mounted(): void {
    this.iniciarComponente();
  }

  @Watch('lieAgregar')
  public watchLieAgregar(): void {
    if (this.lieAgregar?.cveLinea) {
      this.lies = this.lies.filter(lie => lie.cveLinea !== this.lieAgregar.cveLinea);
    }
    this.lies.push(this.lieAgregar);

    this.buscarEnLie();
  }

  private iniciarComponente(): void {
    this.lieSeleccionada = new LieFormSnp();

    this.mostrarModalActivar = false;
    this.mostrarModalDesactivar = false;
    this.mostrarModalEliminar = false;
    this.mostrarModalDetalle = false;

    this.lies = [];

    (this.solicitud?.lies ?? []).forEach(currLie => {
      const instiucionesSede: Array<InstitucionDependenciaLieSnp> = [];

      (currLie.instituciones ?? []).forEach(currInst => {
        (currInst.sedes ?? []).forEach(currSede => {
          instiucionesSede.push({
            claveInstitucion: currInst.claveInstitucion,
            claveDependencia: currSede.claveDependencia,
            nombre: `${currInst.nombreInstitucion} || ${currSede.nombreDependencia} (${currSede.sede})`,
          });
        });
      });

      this.lies.push({
        activo: currLie.activo,
        clasificacion: currLie.clasificacion,
        cveLinea: currLie.cveLinea,
        fechaAlta: currLie.fechaAlta,
        instituciones: instiucionesSede,
        justificacion: currLie.justificacion,
        nombreDeLinea: currLie.nombreDeLinea,
        temasPrioritariosPeciti: currLie.temasPrioritariosPeciti,
      });
    });

    this.buscarEnLie();
  }

  public mostrarModalDetalleLie(lie: LieFormSnp): void {
    this.mostrarModalDetalle = true;
    this.lieSeleccionada = lie;

    this.clasificaciones = [];
    CatalogosSnp.obtenerClasificacionesLies().forEach(it => {
      this.clasificaciones.push({ value: it, text: it.nombre });
    });

    this.instituciones = [];

    if (this.solicitud?.programa?.instituciones) {
      this.solicitud.programa.instituciones.forEach(institucion => {
        (institucion.sedes ?? []).forEach(sede => {
          const institucionSede = `${institucion.nombreInstitucion} || ${sede.nombreDependencia} (${sede.sede})`;
          this.instituciones.push({
            value: {
              claveInstitucion: institucion.claveInstitucion,
              claveDependencia: sede.claveDependencia,
              nombre: institucionSede,
            },
            text: institucionSede,
          });
        });
      });
    }
  }

  public mostrarModalEliminarLie(lie: LieFormSnp): void {
    this.mostrarModalEliminar = true;
    this.lieSeleccionada = lie;
  }

  public mostrarModalDesactivarLie(lie: LieFormSnp): void {
    this.mostrarModalDesactivar = true;
    this.lieSeleccionada = lie;
  }

  public mostrarModalActivarLie(lie: LieFormSnp): void {
    this.mostrarModalActivar = true;
    this.lieSeleccionada = lie;
  }

  public eliminarLie(): void {
    this.lies = this.lies.filter(lie => lie.cveLinea !== this.lieSeleccionada.cveLinea);
    this.mostrarModalEliminar = false;

    this.buscarEnLie();
  }

  @Emit('editarLie')
  public editarLie(lie: LieFormSnp): LieFormSnp {
    const lieClonada = { ...lie };

    this.buscarEnLie();

    return lieClonada;
  }

  public desactivarLie(): void {
    this.lies.forEach(lie => {
      if (this.lieSeleccionada.cveLinea == lie.cveLinea) {
        lie.activo = false;
      }
    });

    this.mostrarModalDesactivar = false;

    this.buscarEnLie();
  }

  public activarLie(): void {
    this.lies.forEach(lie => {
      if (this.lieSeleccionada.cveLinea == lie.cveLinea) {
        lie.activo = true;
      }
    });

    this.mostrarModalActivar = false;

    this.buscarEnLie();
  }

  public guardarLies(): void {
    if (!this.readOnly) {
      const liesGuardar: Array<LieSnp> = [];

      (this.lies ?? []).forEach(currLieForm => {
        const institucionesArbol: Array<InstitucionLieSnp> = [];

        (currLieForm.instituciones ?? []).forEach(currInstForm => {
          const institucionPrograma = (this.solicitud?.programa?.instituciones ?? []).find(
            insttiucion => insttiucion.claveInstitucion == currInstForm.claveInstitucion
          );
          let institucionArbol = institucionesArbol.find(institucion => institucion.claveInstitucion == currInstForm.claveInstitucion);

          if (!institucionArbol) {
            institucionArbol = {
              claveInstitucion: institucionPrograma.claveInstitucion,
              nombreInstitucion: institucionPrograma.nombreInstitucion,
              sedes: [],
            };

            institucionesArbol.push(institucionArbol);
          }

          const sedePrograma = (institucionPrograma.sedes ?? []).find(sede => sede.claveDependencia == currInstForm.claveDependencia);
          const sedeArbol = (institucionArbol.sedes ?? []).find(sede => sede.claveDependencia == currInstForm.claveDependencia);

          if (!sedeArbol) {
            institucionArbol.sedes.push({
              claveDependencia: sedePrograma.claveDependencia,
              claveSede: sedePrograma.claveSede,
              nombreDependencia: sedePrograma.nombreDependencia,
              sede: sedePrograma.sede,
            });
          }
        });

        liesGuardar.push({
          activo: currLieForm.activo,
          clasificacion: currLieForm.clasificacion,
          cveLinea: currLieForm.cveLinea,
          fechaAlta: currLieForm.fechaAlta,
          instituciones: institucionesArbol,
          justificacion: currLieForm.justificacion,
          nombreDeLinea: currLieForm.nombreDeLinea,
          temasPrioritariosPeciti: currLieForm.temasPrioritariosPeciti,
        });
      });

      this.guardarSeccion(liesGuardar);
    }
  }

  @Emit('guardarLies')
  public guardarSeccion(liesGuardar: Array<LieSnp>): Array<LieSnp> {
    return liesGuardar;
  }

  public buscarEnLie(): void {
    this.liesFiltradas = [];

    this.lies.forEach(lie => {
      if (this.filtroLies) {
        if (
          lie.clasificacion?.nombre?.toLowerCase().includes(this.filtroLies.toLowerCase()) ||
          lie.nombreDeLinea?.toLowerCase().includes(this.filtroLies.toLowerCase())
        ) {
          this.liesFiltradas.push(lie);
        }
      } else {
        this.liesFiltradas.push(lie);
      }
    });
  }

  get registros(): number {
    return this.liesFiltradas?.length ?? 0;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
